export default "__VITE_ASSET__CcHkjCm8__"